import React, { createContext, useState, useEffect, useCallback } from 'react';
import { getInventoryItems } from '../firebase/inventoryService';

export const LowStockContext = createContext();

export const LowStockProvider = ({ children }) => {
  const [lowStockItems, setLowStockItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch low stock items
  const fetchLowStockItems = useCallback(async () => {
    try {
      const result = await getInventoryItems();
      if (result.success) {
        // Filter items with stock <= 5, exclude ML-tracked decant items
        const low = result.data.filter(item => !item.trackInML && item.stock <= 5);
        setLowStockItems(low);
      }
    } catch (error) {
      console.error('Error fetching low stock items:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Initial load
  useEffect(() => {
    fetchLowStockItems();
  }, [fetchLowStockItems]);

  // Set up interval to check every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      fetchLowStockItems();
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, [fetchLowStockItems]);

  const value = {
    lowStockItems,
    loading,
    refetch: fetchLowStockItems,
  };

  return (
    <LowStockContext.Provider value={value}>
      {children}
    </LowStockContext.Provider>
  );
};
